import React, { PureComponent } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { styles } from 'gipsy-misc'
import { Checkbox, media } from 'gipsy-ui'

const propTypes = {
  value: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onToggleSelect: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired
}

export class PreferenceChoice extends PureComponent {
  onChange = () => {
    const { value, isSelected, onToggleSelect } = this.props
    if (isSelected) {
      return
    }
    onToggleSelect(value)
  }

  render() {
    const { isSelected, title, subtitle } = this.props

    return (
      <PreferenceChoiceContainer isSelected={isSelected}>
        <Checkbox paramName="isSelected" checked={isSelected} onChange={this.onChange} />
        <TextContainer>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </TextContainer>
      </PreferenceChoiceContainer>
    )
  }
}

const PreferenceChoiceContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  font: ${styles.fonts.primaryFont};
  height: 104px;
  vertical-align: middle;
  line-height: 16px;
  border: 1px solid #ebeaee;
  border-radius: 8px;
  background-color: ${props => props.isSelected && '#ffffff'};
  padding: 32px;

  ${media['phone-wide']`
   padding: 10px;
`}
`

const TextContainer = styled.span`
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 15px;

  ${media['phone-wide']`
    flex-direction: column;
    align-items: flex-start;
  `}
`

const Title = styled.span`
  font-size: ${styles.fonts.fontSizeSmall};
  width: 40%;
  min-width: 40%;

  ${media['phone-wide']`
  min-width: 100%;
  margin-bottom : 4px;
`}
`
const Subtitle = styled.span`
  font-size: ${styles.fonts.fontSizeXSmall};
  width: 55%;
  min-width: 55%;
  text-align: right;

  ${media['phone-wide']`
  min-width: 100%;
  font-size: ${styles.fonts.fontSizeXXSmall};
  text-align:initial;
`}
`

PreferenceChoice.propTypes = propTypes

export default PreferenceChoice



// WEBPACK FOOTER //
// ./src/pages/settings/components/notifications/preferencechoice.js